import React, { useState } from "react";
import {  FaMinus, FaPlus,  FaShieldAlt, FaServer, FaLock, FaDatabase, FaUserShield, FaCodeBranch, FaUserCheck, FaUserLock, FaFileMedical, FaNetworkWired, FaBug, FaGlobe, FaFingerprint, FaKey, FaUserSecret, FaLaptopCode, FaCogs } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/BlockchainCybersecurity inHealthcare.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services =[
    {
        "title": "Blockchain for Medical Records",
        "description":
            "Leverage blockchain technology to establish decentralized, tamper-proof Electronic Health Records (EHR) systems. Blockchain enhances interoperability among healthcare providers, secures patient data against unauthorized access, and ensures a transparent, auditable history of medical transactions. This approach reduces data silos, mitigates fraud, and improves patient trust in healthcare data management."
    },
    {
        "title": "Data Encryption & Privacy",
        "description":
            "Implement advanced encryption standards, such as end-to-end encryption and homomorphic encryption, to secure sensitive patient information. Zero-trust security models reinforce privacy, ensuring that only authorized parties can access healthcare data. Compliance with regulations like HIPAA, GDPR, and HITECH is maintained through stringent access controls and secure data transmission protocols."
    },
    {
        "title": "Smart Contracts in Healthcare",
        "description":
            "Utilize blockchain-powered smart contracts to automate complex healthcare processes, including insurance claims processing, patient consent management, and billing reconciliation. These self-executing contracts enhance transparency, reduce administrative overhead, eliminate intermediaries, and minimize fraudulent activities in healthcare transactions."
    },
    {
        "title": "Identity & Access Management (IAM)",
        "description":
            "Strengthen healthcare security by implementing Identity & Access Management (IAM) solutions, including multi-factor authentication (MFA), biometric security, and role-based access controls (RBAC). IAM systems prevent unauthorized access to patient data, enforce strict authentication policies, and ensure compliance with healthcare security standards such as NIST and ISO 27001."
    },
    {
        "title": "Cyber Threat Detection & Response",
        "description":
            "Deploy AI-driven cybersecurity solutions to continuously monitor, detect, and mitigate emerging threats such as ransomware, phishing, and malware. Real-time threat intelligence, behavior-based anomaly detection, and automated response mechanisms help protect critical healthcare infrastructure, preventing data breaches and minimizing operational disruptions."
    },
    {
        "title": "Secure IoT in Healthcare",
        "description":
            "Enhance the security of medical Internet of Things (IoT) devices, including wearable health monitors, pacemakers, and smart infusion pumps. By integrating blockchain for device authentication, encryption for secure data transmission, and intrusion detection systems (IDS), healthcare organizations can safeguard patient health data, prevent cyberattacks, and ensure the integrity of connected medical devices."
    }
]

const features = [
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "End-to-end encryption for secure medical communications." },
    // { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "HIPAA & GDPR-compliant data security solutions." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Tamper-proof blockchain for medical record integrity." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Multi-factor authentication (MFA) for secure logins." },
    { icon: <FaCodeBranch className="text-[#2a627a] text-lg" />, text: "Decentralized patient identity management with blockchain." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Biometric authentication for patient and doctor verification." }
];
const benefits = [
    { icon: <FaUserLock className="text-[#2a627a] text-lg" />, text: "Protects patient data from breaches and cyberattacks." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Ensures data integrity with immutable blockchain records." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Eliminates single points of failure in healthcare IT systems." },
    { icon: <FaNetworkWired className="text-[#2a627a] text-lg" />, text: "Facilitates secure and seamless data sharing between providers." },
    { icon: <FaBug className="text-[#2a627a] text-lg" />, text: "Detects and neutralizes cyber threats with AI-driven security." },
    { icon: <FaGlobe className="text-[#2a627a] text-lg" />, text: "Enables cross-border medical data sharing securely." }
];
const cmsFeatures = [
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Blockchain Specialist –Designs and implements blockchain-based solutions for secure healthcare data management and privacy protection." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Cybersecurity Specialist – Implements cybersecurity measures to protect healthcare IT systems from threats, ensuring that patient data is secure and compliant with industry standards." },
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Health Data Security Officer – Oversees the management of sensitive health data, ensuring that it is encrypted, protected, and stored securely, while also ensuring compliance with privacy regulations." },
    { icon: <FaLaptopCode className="text-[#2a627a] text-lg" />, text: "Blockchain Developer – Develops blockchain applications and smart contracts to facilitate secure and transparent healthcare transactions." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Security Operations Manager – Manages day-to-day security operations, overseeing the implementation of cybersecurity policies and ensuring that security measures are effective." },
    // { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Medical IoT Security Specialist – Secures connected medical devices from cyber threats." }
];
const Blockchaincybersecurity = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 flex justify-center items-center">Blockchain & cybersecurity - <span className="text-gray-800"> HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Ensuring secure, transparent, and interoperable healthcare systems through blockchain technology and advanced cybersecurity measures."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Blockchain & Cybersecurity in Healthcare? </h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Blockchain and cybersecurity in healthcare focus on using advanced technologies to secure sensitive patient data, ensuring that it remains protected from unauthorized access and tampering. Blockchain technology creates secure, immutable records for medical data, while cybersecurity measures help prevent data breaches and fraud, ensuring compliance with healthcare privacy regulations. Together, these technologies enhance data integrity, transparency, and security across healthcare systems.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Blockchain & cybersecurity
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                Patients can easily manage and update their consent preferences, leading to better engagement with healthcare services and improving trust.Patients can easily manage and update their consent preferences, leading to better engagement with healthcare services and improving trust.
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

<span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Blockchaincybersecurity;
